var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilterableList',{attrs:{"filterConfigs":_vm.filterConfigs,"items":_vm.items,"paginationInfo":_vm.paginationInfo},on:{"get-items":_vm.getItems},scopedSlots:_vm._u([{key:"item",fn:function(){return [_vm._v(" Empty item ")]},proxy:true},{key:"stub",fn:function(){return [_vm._v(" Empty stub ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }